export class PubSubConstants {
    static readonly EVENTS = {
        ON_EXPAND_LEFT_NAV: 'on_expand_left_nav',
        ON_SHOW_HEADER: 'on_show_header',
        REDIRECT_ROUTE: 'redirecty_route'
    };
}
